import React from "react"
import {Avatar, Dropdown, Modal} from "antd"
import {PoweroffOutlined, UserOutlined} from "@ant-design/icons"
import {createUseStyles} from "react-jss"
import {useAuth0} from "@auth0/auth0-react"
import LanguageSelector from "../../components/selector/LanguageSelector";
import AppSelector from "../../components/selector/AppSelector";


const useStyles = createUseStyles(() => ({
    firstNavBlock: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: "15px"
    }
}))

interface HeaderRightBlockProps {
    extra?: React.ReactNode
}

const HeaderRightBlock: React.FC<HeaderRightBlockProps> = ({extra}) => {
    const classes = useStyles()
    const {user, logout} = useAuth0()

    // Выйти из системы
    const onLogoutHandler = () => {
        Modal.confirm({
            title: "Вы действительно хотите выйти?",
            onOk: () => logout({logoutParams: {returnTo: window.origin}})
        })
    }

    const items = [
        {
            label: "Выйти",
            key: "logout",
            icon: <PoweroffOutlined/>,
            onClick: onLogoutHandler
        }
    ]

    return (
        <div className={classes.firstNavBlock}>
            {extra}
            <LanguageSelector/>
            <AppSelector/>
            <Dropdown menu={{items}} arrow>
                <div>
                    <Avatar
                        icon={<UserOutlined/>}
                        src={user?.picture}
                        style={{verticalAlign: "middle", background: "#016f4d"}}
                    />
                </div>
            </Dropdown>
        </div>
    )
}

export default HeaderRightBlock